import React, { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useMemberGroupData } from 'hooks/useMemberGroupData';

import { formatDate, getRelationshipToToday } from 'libs/utils';

import { InfoCard } from 'components/ui/InfoCard';

import { Bumper, GridListWrapper } from 'styles/shared';
import { Fonts, spacing } from 'styles/theme';

export const ValuesList = () => {
    const { values } = useMemberGroupData();

    const [, setSearchParams] = useSearchParams();

    const hasCompletedValuesToday = useMemo(() => {
        let isValuesDateToday = false;
        values.forEach((value) => {
            if (
                getRelationshipToToday(new Date(value.created_at ?? 0)) ===
                'current'
            ) {
                isValuesDateToday = true;
            }
        });
        return isValuesDateToday;
    }, [values]);

    const onSelectNewValues = useCallback(() => {
        setSearchParams({
            modalContent: 'values-submit',
        });
    }, [setSearchParams]);

    const onSelectPreviousValues = useCallback(
        (valuesId: string) => () => {
            setSearchParams({
                modalContent: 'values-results',
                valuesId: valuesId.toString(),
            });
        },
        [setSearchParams]
    );

    return (
        <>
            <Bumper $minHeight={spacing.small} />
            <Fonts.MediumQuote>
                {`Capture and reflect on your core values here to stay connected to what matters most to you.`}
            </Fonts.MediumQuote>
            <Bumper />
            <GridListWrapper $gap={spacing.large}>
                {hasCompletedValuesToday ? (
                    <InfoCard
                        dateRelationship="current"
                        headerText={formatDate(new Date())}
                        mainText="Submit New Values Exercise"
                        onClick={onSelectNewValues}
                    />
                ) : (
                    <InfoCard
                        dateRelationship="current"
                        headerText={formatDate(new Date())}
                        mainText="Start Values Exercise"
                        onClick={onSelectNewValues}
                    />
                )}
                {values.map((value) => (
                    <InfoCard
                        key={value.period}
                        dateRelationship="previous"
                        headerText={formatDate(new Date(value.created_at ?? 0))}
                        mainText="View Values Exercise Results"
                        onClick={onSelectPreviousValues(value.id)}
                    />
                ))}
            </GridListWrapper>
            <Bumper $minHeight={spacing.xxxSmall} />
        </>
    );
};
